// extracted by mini-css-extract-plugin
export var avatarContainer = "_6j-0";
export var avatarTypingWave = "_6j-i";
export var gray = "_6j-f";
export var green = "_6j-c";
export var icon = "_6j-9";
export var image = "_6j-1";
export var lg = "_6j-6";
export var md = "_6j-5";
export var presenceDot = "_6j-b";
export var red = "_6j-d";
export var sm = "_6j-4";
export var status = "_6j-a";
export var typingDot = "_6j-h";
export var typingPill = "_6j-g";
export var xl = "_6j-7";
export var xs = "_6j-3";
export var xxl = "_6j-8";
export var xxs = "_6j-2";
export var yellow = "_6j-e";